import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { baseUrl } from "../../Components/baseUrl";
import Menu from "../../Components/Menu";
import { toast } from "react-toastify";
import GiftModal from "../../Components/GiftModal";
import DescriptionModal from "../../Components/DescriptionModal";
import { CopyToClipboard } from "react-copy-to-clipboard";

const Product = () => {
    const navigate = useNavigate();
    let user;
    const { productId, shopId } = useParams();
    if (typeof window !== "undefined") {
        user = localStorage.getItem("user");
    }
    const [productDetail, setProductDetail] = useState([]);
    const [cartLoading, setCartLoading] = useState(true);
    const productHandler = () => {
        let config = {
            url: `${baseUrl}/${shopId}/products/${productId}`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                setCartLoading(false);
                let productDetail = res.data.data;
                productDetail.num = 0;
                setProductDetail(productDetail);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    console.log(productDetail);
    useEffect(() => {
        document.title = "ویزیت | محصول";
        productHandler();
    }, []);
    const [gift, setGift] = useState([]);
    const [showGiftModal, setShowGiftModal] = useState(false);
    const [description, setDescription] = useState([]);
    const [showDescription, setShowDescription] = useState(false);

    // Gallery
    const [showGallery, setShowGallery] = useState(false);
    const [galleryImages, setGalleryImages] = useState([]);

    const openGallery = (images) => {
        setGalleryImages(images);
        setShowGallery(true);
    };

    const closeGallery = () => {
        setShowGallery(false);
    };

    const likeHandler = (id, stts) => {
        let data = new FormData();
        data.append("product_id", id);
        data.append("status", stts == "like" ? 1 : 0);
        let config = {
            method: "POST",
            url: `${baseUrl}/favourite`,
            data: data,
        };
        axios(config)
            .then((response) => {
                productHandler();
            })
            .catch(function (err) {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    const copyHandler = (item) => {
        toast.success("آدرس محصول کپی شد", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    const [allAmount, setAllAmount] = useState(0);
    const [loading, setLoading] = useState(true);
    const increaseHandler = (item) => {
        const productToUpdate = productDetail;
        if (item.max_order) {
            if (
                productToUpdate.num < item.max_order &&
                productToUpdate.num < item.inventory
            ) {
                let i = productDetail;
                productDetail.num++;
                setProductDetail(i);
                setAllAmount(allAmount + Number(item.unit_price));
            } else {
                toast.error("تعداد سفارش بیشتر از حد مجاز.", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } else {
            if (productToUpdate.num < item.inventory) {
                let i = productDetail;
                productDetail.num++;
                setProductDetail(i);
                setAllAmount(allAmount + Number(item.unit_price));
            } else {
                toast.error("تعداد سفارش بیشتر از حد مجاز.", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    };
    const decreaseHandler = (item) => {
        let i = productDetail;
        const foundItem = productDetail;
        foundItem.num >= 0 && --foundItem.num;
        foundItem.num >= 0 && setAllAmount(allAmount - Number(item.unit_price));
        setProductDetail(i);
    };
    const addToCartHandler = (e) => {
        setCartLoading(true);
        let items = [];
        let userId = JSON.parse(user).id;

        productDetail.num &&
            productDetail.num !== 0 &&
            items.push({
                company_id: shopId,
                product_id: productDetail.id,
                product_count: productDetail.num,
            });
        let data = {
            orders: items,
        };
        let config = {
            url: `${baseUrl}/orders`,
            method: "POST",
            data: data,
        };
        axios(config)
            .then((resp) => {
                let config2 = {
                    url: `${baseUrl}/orders/${resp.data.data.order_id}/confirm-cancel?status=confirm`,
                    method: "GET",
                };
                resp.data &&
                    resp.data.data &&
                    axios(config2)
                        .then((res) => {
                            setCartLoading(false);
                            setAllAmount(0);
                            productHandler();
                            res &&
                                res.data &&
                                res.data.message &&
                                toast.success(
                                    "با موفقیت به سبد خرید اضافه شد",
                                    {
                                        position: "top-center",
                                        autoClose: 5000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                    }
                                );
                        })
                        .catch((err) => {
                            setCartLoading(false);
                            toast.error(err.response.data.message, {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                        });
            })
            .catch((err) => {
                setCartLoading(false);
                err.response &&
                    err.response.data &&
                    toast.error(err.response.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
            });
    };

    return (
        <div className="container">
            <div className="product-main">
                {productDetail && productDetail.length !== 0 && (
                    <div key={productDetail.id} className="product-card">
                        <div className="row-1">
                            <div className="img-div">
                                {productDetail.Images &&
                                productDetail.Images[0] ? (
                                    <div
                                        className="img-div"
                                        onClick={() =>
                                            openGallery(productDetail.Images)
                                        }
                                    >
                                        <img
                                            src={productDetail.Images[0].image}
                                            alt=""
                                        />
                                    </div>
                                ) : (
                                    <div className="img-div">
                                        <img
                                            src={productDetail.Images}
                                            alt=""
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="like-div">
                                {!productDetail.is_favourite ? (
                                    <svg
                                        onClick={() => {
                                            likeHandler(
                                                productDetail.id,
                                                "like"
                                            );
                                        }}
                                        className="no-like"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M17.1999 21.9999C19.8509 21.9999 21.9999 19.8509 21.9999 17.1999C21.9999 14.5489 19.8509 12.3999 17.1999 12.3999C14.5489 12.3999 12.3999 14.5489 12.3999 17.1999C12.3999 19.8509 14.5489 21.9999 17.1999 21.9999Z"
                                            stroke="#292D32"
                                            strokeWidth="1.5"
                                            strokeMiterlimit="10"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M18.9899 17.2598H15.4099"
                                            stroke="#292D32"
                                            strokeWidth="1.5"
                                            strokeMiterlimit="10"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M17.2 15.5098V19.0997"
                                            stroke="#292D32"
                                            strokeWidth="1.5"
                                            strokeMiterlimit="10"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            opacity="0.4"
                                            d="M22 8.69012C22 10.6601 21.49 12.4001 20.69 13.9101C19.81 12.9801 18.57 12.4001 17.2 12.4001C14.55 12.4001 12.4 14.5501 12.4 17.2001C12.4 18.4301 12.87 19.5501 13.63 20.4001C13.26 20.5701 12.92 20.7101 12.62 20.8101C12.28 20.9301 11.72 20.9301 11.38 20.8101C8.48 19.8201 2 15.6901 2 8.69012C2 5.60012 4.49 3.1001 7.56 3.1001C9.37 3.1001 10.99 3.98014 12 5.33014C13.01 3.98014 14.63 3.1001 16.44 3.1001C19.51 3.1001 22 5.60012 22 8.69012Z"
                                            stroke="#292D32"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        onClick={() => {
                                            likeHandler(
                                                productDetail.id,
                                                "des"
                                            );
                                        }}
                                        className="liked"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M12.62 20.8101C12.28 20.9301 11.72 20.9301 11.38 20.8101C8.48 19.8201 2 15.6901 2 8.6901C2 5.6001 4.49 3.1001 7.56 3.1001C9.38 3.1001 10.99 3.9801 12 5.3401C13.01 3.9801 14.63 3.1001 16.44 3.1001C19.51 3.1001 22 5.6001 22 8.6901C22 15.6901 15.52 19.8201 12.62 20.8101Z"
                                            fill="#FF0000"
                                        />
                                    </svg>
                                )}
                            </div>
                            <div>
                                <div className="marquee">
                                    <h4
                                        className={
                                            productDetail.name.length < 13
                                                ? "name"
                                                : productDetail.name.length < 25
                                                ? "name moving-2"
                                                : "name moving"
                                        }
                                    >
                                        <span>{productDetail.name}</span>
                                    </h4>
                                </div>
                                <div className="d-flex-center">
                                    <span className="price-span-1">
                                        قیمت واحد:
                                    </span>
                                    <span className="price-span-2">
                                        {Number(
                                            productDetail.unit_price
                                        ).toLocaleString()}{" "}
                                        تومان
                                    </span>
                                </div>
                                <div className="d-flex-center">
                                    <span className="muted-span-1">
                                        قیمت فروشگاه:
                                    </span>
                                    <span className="muted-span-2">
                                        {Number(
                                            productDetail.store_price
                                        ).toLocaleString()}{" "}
                                        تومان
                                    </span>
                                </div>
                                <div className="d-flex-center">
                                    <span className="muted-span-1">
                                        قیمت مصرف کننده:
                                    </span>
                                    <span className="muted-span-2">
                                        {Number(
                                            productDetail.consumer_price
                                        ).toLocaleString()}{" "}
                                        تومان
                                    </span>
                                </div>
                                <div className="d-flex-center">
                                    <span className="muted-span-1">
                                        تعداد در واحد:
                                    </span>
                                    <span className="muted-span-2">
                                        {productDetail.unit_count}{" "}
                                        {productDetail.measure_unit.name}
                                    </span>
                                </div>
                            </div>
                            <div
                                className="gift"
                                onClick={() => {
                                    setGift(productDetail.Gifts);
                                    setShowGiftModal(true);
                                }}
                            >
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M14.9775 7.5H2.97754V13.5C2.97754 15.75 3.72754 16.5 5.97754 16.5H11.9775C14.2275 16.5 14.9775 15.75 14.9775 13.5V7.5Z"
                                        stroke="#3BA7E4"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M16.125 5.25V6C16.125 6.825 15.7275 7.5 14.625 7.5H3.375C2.2275 7.5 1.875 6.825 1.875 6V5.25C1.875 4.425 2.2275 3.75 3.375 3.75H14.625C15.7275 3.75 16.125 4.425 16.125 5.25Z"
                                        stroke="#3BA7E4"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        opacity="0.4"
                                        d="M8.73008 3.75008H4.59008C4.33508 3.47258 4.34258 3.04508 4.61258 2.77508L5.67758 1.71008C5.95508 1.43258 6.41258 1.43258 6.69008 1.71008L8.73008 3.75008Z"
                                        stroke="#3BA7E4"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        opacity="0.4"
                                        d="M13.4025 3.75008H9.26245L11.3025 1.71008C11.58 1.43258 12.0375 1.43258 12.315 1.71008L13.38 2.77508C13.65 3.04508 13.6575 3.47258 13.4025 3.75008Z"
                                        stroke="#3BA7E4"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        opacity="0.4"
                                        d="M6.70508 7.5V11.355C6.70508 11.955 7.36508 12.3075 7.86758 11.985L8.57258 11.52C8.82758 11.355 9.15008 11.355 9.39758 11.52L10.0651 11.97C10.5601 12.3 11.2276 11.9475 11.2276 11.3475V7.5H6.70508Z"
                                        stroke="#3BA7E4"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                        </div>
                        <div className="row-2">
                            <div className="count">
                                <button
                                    className="count-btn plus"
                                    aria-label="Increase by one"
                                    onClick={() =>
                                        increaseHandler(productDetail)
                                    }
                                >
                                    <svg
                                        width="15"
                                        height="15"
                                        viewBox="0 0 15 15"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M7.5 1L7.5 14"
                                            stroke="#0085FF"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            d="M14 7.5L1 7.5"
                                            stroke="#0085FF"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </button>
                                <span className="num number dim">
                                    {productDetail.num}
                                </span>
                                <button
                                    onClick={() =>
                                        productDetail.num > 0 &&
                                        decreaseHandler(productDetail)
                                    }
                                    className="count-btn"
                                    aria-label="Decrease by one"
                                >
                                    <svg
                                        width="15"
                                        height="1"
                                        viewBox="0 0 15 1"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M14 0.5L1 0.5"
                                            stroke="#0085FF"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div className="inventory">
                                <svg
                                    width="22"
                                    height="22"
                                    viewBox="0 0 22 22"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M10.9999 4.58325L6.92992 1.83325L1.83325 5.49992L5.90325 8.24992L10.9999 4.58325Z"
                                        stroke="black"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M11 4.58325L15.07 1.83325L20.1667 5.49992L16.0967 8.24992L11 4.58325Z"
                                        stroke="black"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M10.9999 12.8334L6.92992 15.5834L1.83325 11.9167L5.90325 9.16675L10.9999 12.8334Z"
                                        stroke="black"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M11 12.8334L15.07 15.5834L20.1667 11.9167L16.0967 9.16675L11 12.8334Z"
                                        stroke="black"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        opacity="0.4"
                                        d="M17.4166 14.2083V17.2057L11.3849 19.9924C11.1374 20.1024 10.8624 20.1024 10.6149 19.9924L4.58325 17.2057V14.2083"
                                        stroke="black"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <span>موجودی:</span>
                                <span className="inv-num">
                                    {productDetail.inventory}
                                </span>
                            </div>
                        </div>
                        <div className="d-flex-center pro-row">
                            <div className="d-flex-center">
                                <div className="price-blue min-w-160">
                                    <svg
                                        width="21"
                                        height="21"
                                        viewBox="0 0 21 21"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g opacity="0.4">
                                            <path
                                                d="M7.4375 12.4688C7.4375 14.1487 8.82 15.5312 10.5 15.5312C12.18 15.5312 13.5625 14.1487 13.5625 12.4688"
                                                stroke="#0085FF"
                                                strokeWidth="1.5"
                                                strokeMiterlimit="10"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M7.70827 1.75L4.54077 4.92625"
                                                stroke="#0085FF"
                                                strokeWidth="1.5"
                                                strokeMiterlimit="10"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M13.2908 1.75L16.4583 4.92625"
                                                stroke="#0085FF"
                                                strokeWidth="1.5"
                                                strokeMiterlimit="10"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </g>
                                        <path
                                            d="M1.75 6.86865C1.75 5.2499 2.61625 5.11865 3.6925 5.11865H17.3075C18.3838 5.11865 19.25 5.2499 19.25 6.86865C19.25 8.7499 18.3838 8.61865 17.3075 8.61865H3.6925C2.61625 8.61865 1.75 8.7499 1.75 6.86865Z"
                                            stroke="#0085FF"
                                            strokeWidth="1.5"
                                        />
                                        <path
                                            d="M3.0625 8.75L4.29625 16.31C4.57625 18.0075 5.25 19.25 7.7525 19.25H13.0288C15.75 19.25 16.1525 18.06 16.4675 16.415L17.9375 8.75"
                                            stroke="#0085FF"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                    <span className="price-n">
                                        {Number(
                                            productDetail.unit_price *
                                                productDetail.num
                                        ).toLocaleString()}
                                    </span>
                                    <span>تومان</span>
                                </div>
                                {productDetail.discount_percent
                                    ? productDetail.discount_percent !== 0 && (
                                          <span className="discount">
                                              {productDetail.discount_percent}%
                                          </span>
                                      )
                                    : ""}
                            </div>
                            <CopyToClipboard
                                text={
                                    "https://my.payacom.com/panel/product/" +
                                    productDetail.company_id +
                                    "/" +
                                    productDetail.id
                                }
                            >
                                <svg
                                    className="mt-10"
                                    width="48"
                                    height="28"
                                    viewBox="0 0 48 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    onClick={() => {
                                        copyHandler(productDetail);
                                    }}
                                >
                                    <rect
                                        width="48"
                                        height="28"
                                        rx="14"
                                        fill="#CCEDFF"
                                    />
                                    <path
                                        d="M28.96 8.16992C30.96 9.55992 32.34 11.7699 32.62 14.3199"
                                        stroke="#3BA7E4"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M15.49 14.37C15.75 11.83 17.11 9.61997 19.09 8.21997"
                                        stroke="#3BA7E4"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M20.1899 22.9399C21.3499 23.5299 22.6699 23.8599 24.0599 23.8599C25.3999 23.8599 26.6599 23.5599 27.7899 23.0099"
                                        stroke="#3BA7E4"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M21.28 6.91989C21.28 8.44989 22.52 9.69989 24.06 9.69989C25.6 9.69989 26.84 8.45989 26.84 6.91989C26.84 5.37989 25.6 4.13989 24.06 4.13989"
                                        stroke="#3BA7E4"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M16.83 21.9201C18.3654 21.9201 19.61 20.6755 19.61 19.1401C19.61 17.6048 18.3654 16.3601 16.83 16.3601C15.2947 16.3601 14.05 17.6048 14.05 19.1401C14.05 20.6755 15.2947 21.9201 16.83 21.9201Z"
                                        stroke="#3BA7E4"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M33.9399 19.1401C33.9399 17.6101 32.6999 16.3601 31.1599 16.3601C29.6199 16.3601 28.3799 17.6001 28.3799 19.1401C28.3799 20.6801 29.6199 21.9201 31.1599 21.9201"
                                        stroke="#3BA7E4"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </CopyToClipboard>
                        </div>
                        {productDetail.description && (
                            <div className="info-div">
                                <svg
                                    onClick={() => {
                                        setDescription(
                                            productDetail.description
                                        );
                                        setShowDescription(true);
                                    }}
                                    width="25"
                                    height="25"
                                    viewBox="0 0 25 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M12.4999 22.9166C18.2291 22.9166 22.9166 18.2291 22.9166 12.4999C22.9166 6.77075 18.2291 2.08325 12.4999 2.08325C6.77075 2.08325 2.08325 6.77075 2.08325 12.4999C2.08325 18.2291 6.77075 22.9166 12.4999 22.9166Z"
                                        stroke="#FF9A51"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        opacity="0.6"
                                        d="M12.5 8.33325V13.5416"
                                        stroke="#FF9A51"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        opacity="0.6"
                                        d="M12.4944 16.6667H12.5037"
                                        stroke="#FF9A51"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                        )}
                    </div>
                )}
                <div className=" mt-4"></div>
                {cartLoading ? (
                    <div className="add-to-cart">
                        <div className="mx-auto d-flex justify-content-center">
                            <img src="/assets/images/loading.gif" width={20} />
                        </div>
                    </div>
                ) : (
                    <div onClick={addToCartHandler} className="add-to-cart">
                        افزودن به سبد خرید
                    </div>
                )}
                <Menu active="shop" />
            </div>
        </div>
    );
};

export default Product;
